import type { Quest, QuestGroup, QuestOrder } from "@ui-kit/QuestList";

export const reorderQuestsBySkipOrder = (
  QuestGroupData: QuestGroup[],
  QuestOrdering: QuestOrder,
): QuestGroup[] => {
  // Create a flattened array of all quests from all groups
  const allQuests = QuestGroupData.flatMap((group) => group.quests);

  return QuestGroupData.map((group) => {
    // Create a shallow copy of the group and its quests array to avoid mutation
    const newGroupData: QuestGroup = { ...group, quests: [...group.quests] };

    // Find ordering for this group, if it exists
    const matchedGroup = QuestOrdering.find(
      (orderGroup) => orderGroup.key === group.key,
    );
    if (!matchedGroup) return newGroupData;

    const orderedQuests: Quest[] = [];

    // Iterate over the specified order and add matching quests from anywhere in the quest groups
    for (const orderItem of matchedGroup.quests) {
      // Search for a quest with the given ruleId in the flattened list of all quests
      const quest = allQuests.find((q) => q.ruleId === orderItem.ruleId);

      if (quest) {
        orderedQuests.push({
          ...quest,
          badgeTemplate: quest.badgeTemplate,
          label: quest.label,
          caption: quest.caption,
          linkUrl: quest.type === "link" ? quest.linkUrl : "#",
        });
      }
    }

    // Replace the current group's quests with the newly ordered quests
    newGroupData.quests = orderedQuests;

    return newGroupData;
  });
};
